import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-profile-page',
  standalone: true,
  imports: [CommonModule],
  template: `
    <section class="card">
      <h2>Profile</h2>
      @if (account(); as user) {
        <p><strong>Name:</strong> {{ user.name ?? 'Unknown' }}</p>
        <p><strong>Username:</strong> {{ user.username }}</p>
      } @else {
        <p>You are not signed in.</p>
      }
    </section>
  `,
  styles: [
    `
      .card {
        background: color-mix(in srgb, var(--color-surface-2) 92%, transparent);
        border: 1px solid var(--color-border);
        border-radius: 0.9rem;
        padding: 1rem;
      }

      h2 {
        margin: 0 0 0.5rem;
      }

      p {
        color: var(--color-muted);
      }
    `
  ]
})
export class ProfilePageComponent {
  private readonly authService = inject(AuthService);
  readonly account = computed(() => this.authService.getActiveAccount());
}
